import { useEffect } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/nl-be';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { RawIntlProvider } from 'react-intl';
// eslint-disable-next-line import/no-extraneous-dependencies
import { applyPolyfills, defineCustomElements } from '@a-ui/web-components/loader';
import Footer from './components/Footer';
import SkipLink from './components/SkipLink';
import { intl } from './i18n/config';
import Router from './routes/router';
import GlobalStateProvider from './state/GlobalStateProvider';

const App = () => {
  dayjs.locale('nl-be');
  dayjs.extend(customParseFormat);
  dayjs.extend(utc);
  dayjs.extend(timezone);

  useEffect(() => {
    applyPolyfills().then(() => {
      defineCustomElements(window);
    });
  }, []);

  return (
    <GlobalStateProvider>
      <RawIntlProvider value={intl}>
        <SkipLink />
        <Router />
        <Footer />
      </RawIntlProvider>
    </GlobalStateProvider>
  );
};

export default App;
